export const markDownLevels = {
  wrongDefect: 5,
  wrongDepth: 2,
};
